import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NotificacoesService } from 'src/app/notificacoes/notificacoes.service';
import { MensagensService } from '../mensagens/mensagens.service';
import { Bandeira } from '../models/bandeira.enum';
import { Notificacao } from '../models/notificacao.model';
import { AutenticacaoService } from './../../seguranca/autenticacao.service';
import { LoaderService } from './../loader/loader.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  notificacoes: Notificacao[] = [];
  isRouteWithNewUx = false;

  title$: Observable<string>;

  constructor(
    public router: Router,
    public autenticacaoService: AutenticacaoService,
    public loaderService: LoaderService,
    public notificacaoService: NotificacoesService,
    public mensagensService: MensagensService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.handleConfigUI();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.handleConfigUI();
      }
    })
  }

  handleConfigUI() {
    const { snapshot } = this.activatedRoute
    const [activeRoute] = snapshot.children;
    this.isRouteWithNewUx = activeRoute.data.newUX ?? false
  }
}
